import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_pt47qddvxc: FaireBrandEntity = {
  token: "b_pt47qddvxc",
  type: "brand",
  name: "Mindful and Co Kids USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/bde53e0bce51b562c3550665389ef31f62141fdf6e9369f833e2fcf2ea4ad12f.webp",
  bannerUrl:
    "https://cdn.faire.com/fastly/5f63ad39826f766a805aa8500a287d98a7442b0fa7c1d5958e1f1ddb5e58ba0c.webp",
  logoUrl:
    "https://cdn.faire.com/fastly/bde53e0bce51b562c3550665389ef31f62141fdf6e9369f833e2fcf2ea4ad12f.webp",
  heroImageUrl:
    "https://cdn.faire.com/fastly/5f63ad39826f766a805aa8500a287d98a7442b0fa7c1d5958e1f1ddb5e58ba0c.webp",
  location: "San Diego, CA, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 30,
  isInsider: false,
  description:
    "Born in Australia in 2019, Mindful & Co Kids was founded by Jacqueline Yeats, a psychotherapist specialising in Mindfulness as an early intervention for stress disorders. Inspired by her research in this area, Jacqueline created a range of fun and educational games to raise awareness of the myriad of benefits to promoting mindfulness and yoga for children. They exist for one simple mission: To empower the next generation to slow their minds, shift their limiting beliefs, and embrace the powerful benefits of thoughtful living through a holistic approach to wellness. Mindful & Co Kids believe teaching our children mindfulness at an early age will not only become a positive ripple effect that flows into their lives, but will work to bring their family and relationships closer together. At the same time, it will inspire them to be more focused and engaged learners, and ultimately live happier, positive, and more fulfilled lives.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:19.418Z",
    importedBy: "entity-db-cli",
  },
};
